import { combineReducers } from "redux";
import { loginReducer } from "./login/loginReducer";
import { pricingReducer } from "./pricing/pricingReducer";

export const allReducers = combineReducers({
    login: loginReducer,
    pricing: pricingReducer

})